import React from 'react';
import { HashRouter } from 'react-router-dom';
import { createHashHistory, createBrowserHistory } from 'history';

const history = createBrowserHistory({ queryKey: false });

export default ({ children }) => (
    <HashRouter history={history}>
        {children}            
    </HashRouter>
)